import React from 'react';

import StationMapSheet from './StationMapSheet';
import useStationMapData from './useStationMapData';

interface ConnectedStationMapSheetProps {
    direction: string;
    isOpen: boolean;
    onClose: () => void;
}

function ConnectedStationMapSheet({ direction, isOpen, onClose }: ConnectedStationMapSheetProps) {
    const data = useStationMapData(direction);
    if (!data) return null;
    return (
        <StationMapSheet
            {...data}
            isOpen={isOpen}
            onClose={onClose}
        />
    );
}

export default React.memo(ConnectedStationMapSheet);
